import { getSentCandidateforJobEmp } from "../../../services/jobService";
import { viewResume } from "../../../services/candidateService";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  Modal,
  Button,
  Form,
  Toast,
  ToastContainer,
  ModalBody,
} from "react-bootstrap";

const GetSentCandidateforJob = () => {
  const { jobUID } = useParams();
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [modalType, setModalType] = useState("");
  const [remark, setRemark] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showJobTitleFilter, setShowJobTitleFilter] = useState(false);
  const [filteredTitles, setFilteredTitles] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [searchTitleText, setSearchTitleText] = useState("");
  const [resumeUrl, setResumeUrl] = useState("");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "success",
  });
  const [showCandidateModal, setShowCandidateModal] = useState(false);
  const navigate = useNavigate();
  const totalRecords = candidates.length;

  useEffect(() => {
    const sentCandidate = async () => {
      try {
        const response = await getSentCandidateforJobEmp(jobUID);
        if (response) {
          setCandidates(response.data.candidateList);
          console.log(response);
        }
      } catch (error) {
        console.log(error.response.data.message);
      }
    };
    sentCandidate();
  }, [jobUID]);

  const openModal = (candidate, type) => {
    setSelectedCandidate(candidate);
    setModalType(type);
    setRemark("");
  };

  const jobTitles = [...new Set(candidates.map((c) => c.jobTitel))];

  const handleFilterIconClick = () => {
    setShowJobTitleFilter(true);
    setFilteredTitles(jobTitles);
    setSelectedTitles(jobTitles);
    setSearchTitleText("");
  };

  const handleSearchTitleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTitleText(value);
    setFilteredTitles(
      jobTitles.filter((title) => title.toLowerCase().includes(value))
    );
  };

  const handleSelectTitle = (title) => {
    if (selectedTitles.includes(title)) {
      setSelectedTitles(selectedTitles.filter((t) => t !== title));
    } else {
      setSelectedTitles([...selectedTitles, title]);
    }
  };

  const handleSelectAllTitles = (checked) => {
    setSelectedTitles(checked ? jobTitles : []);
  };

  const filteredCandidates = candidates.filter(
    (candidate) =>
      (selectedTitles.length === 0 ||
        selectedTitles.includes(candidate.jobTitel)) &&
      [
        candidate.candidateName,
        candidate.jobTitel,
        candidate.email,
        candidate.mobile,
        candidate.submitedBy,
      ].some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const hasCandidates = candidates.length > 0;
  const hasFilteredCandidates = filteredCandidates.length > 0;

  const [currentPage, setCurrentPage] = useState(1);
  const [candidatesPerPage, setCandidatesPerPage] = useState(10);
  const indexOfLastCandidate = currentPage * candidatesPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
  const currentCandidates = filteredCandidates.slice(
    indexOfFirstCandidate,
    indexOfLastCandidate
  );
  const totalPages = Math.ceil(filteredCandidates.length / candidatesPerPage);
  const goToPage = (pageNumber) => setCurrentPage(pageNumber);
  const goToNext = () =>
    currentPage < totalPages && setCurrentPage((prev) => prev + 1);
  const goToPrev = () => currentPage > 1 && setCurrentPage((prev) => prev - 1);

  const openCandidateModal = (candidate) => {
    setSelectedCandidate(candidate);
    setShowCandidateModal(true);
  };

  const closeCandidateModal = () => {
    setShowCandidateModal(false);
    setSelectedCandidate(null);
  };

  // Modal Open when Clicked on name 
  const handleNameClick = (candidate) => {
   setSelectedCandidate(candidate);
    setShowCandidateModal(true);
  };

  return (
    <>
      <div className="jobs-container container mt-5 pt-5">
        <ToastContainer position="top-end" className="p-3">
          <Toast
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
            show={toast.show}
            delay={3000}
            autohide
          >
            <Toast.Body className="text-white fw-semibold">
              {toast.message}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        <div className="jobs-card shadow-sm">
          <div className="jobs-header d-flex justify-content-between align-items-center">
            <h3 className="fw-bold mb-0">Sent Candidates For this Job</h3>
          </div>

          {/* Search bar & Records*/}
          <div className="jobs-toolbar d-flex flex-wrap align-items-center gap-3 my-3 w-100">
            <div
              className="input-group rounded-pill border bg-white shadow-sm"
              style={{ maxWidth: "350px" }}
            >
              <span className="input-group-text bg-transparent border-0 ps-3">
                <i className="bi bi-search text-secondary"></i>
              </span>
              <input
                type="text"
                className="form-control border-0 rounded-5 shadow-none"
                placeholder="Search by name, title etc"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          {/* table */}
          <div className="Overflow-Auto">
            <table className="table modern-table align-middle">
              <thead>
                <tr>
                  <th>#</th>
                  <th style={{ whiteSpace: "nowrap", width: "120px" }}>
                    Job Title
                    <i
                      className="bi bi-caret-down-fill mx-2"
                      onClick={handleFilterIconClick}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </th>
                  <th> Submitted By</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile Number</th>
                  <th>Status</th>
                  <th>Submitted At </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentCandidates.length > 0 ? (
                  currentCandidates.map((candidate, index) => (
                    <tr key={candidate.id || index}>
                      {/* <td>{indexOfFirstJob + idx + 1}</td> */}
                      <td>{indexOfFirstCandidate + index + 1}</td>
                      <td>{candidate.jobTitel || "-"}</td>
                      <td>{candidate.submitedBy || "-"}</td>
                      <td
                      onClick={() => handleNameClick(candidate)}
                        className="text-primary fw-semibold"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                      >{candidate.candidateName || "-"}</td>
                      <td>{candidate.email || "-"}</td>
                      <td>{candidate.mobile || "-"}</td>
                      <td>{candidate.status || "-"}</td>
                      <td>
                        {new Date(candidate.submitDate).toLocaleDateString(
                          "en-GB"
                        )}
                      </td>
                      <td className="px-3" style={{ fontSize: "1.5em" }}>
                        <div className="dropdown d-inline mx-3 position-relative">
                          <style>{`
                                             .table-responsive {
                                             overflow: visible !important;
                                             }
                                             .table-responsive .dropdown-menu {
                                             z-index: 9999;
                                            position: absolute !important;
                                            transform: translate(0, 0) !important;
                                            will-change: transform;
                                            }
                                            `}</style>

                          <i
                            className="bi bi-three-dots-vertical"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ></i>
                          <ul className="dropdown-menu">
                            {/* <li>
                            <button
                              className="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#candidateModal"
                              onClick={() =>
                                openModal(candidate, "CandidateDetails")
                              }
                            >
                              <i className="bi bi-eye-fill me-2"></i> View
                              Details
                            </button>
                          </li> */}
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => openCandidateModal(candidate)}
                              >
                                <i className="bi bi-eye-fill me-2"></i> View
                                Details
                              </button>
                            </li>

                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => {
                                  if (candidate.resumePath) {
                                    const url = viewResume(
                                      candidate.resumePath
                                    );
                                    setResumeUrl(url);
                                    setShowResumeModal(true);
                                  } else {
                                    alert("Resume not available.");
                                  }
                                }}
                              >
                                <i className="bi bi-file-earmark-text me-2"></i>{" "}
                                Resume
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-danger py-3">
                      {hasCandidates
                        ? "No application found."
                        : "No new applications received."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalRecords > 10 && (
            <div className="d-flex justify-content-end align-items-center mt-3 gap-3">
              <div className="d-flex align-items-center">
                <label className="me-2 fw-semibold">Items Per Page:</label>
                <Form.Select
                  className="form-select form-select-sm w-auto"
                  value={candidatesPerPage}
                  onChange={(e) => {
                    setCandidatesPerPage(parseInt(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </div>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      <i class="bi bi-chevron-left"></i>
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${
                        currentPage === idx + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(idx + 1)}
                      >
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* Job Title Filter Modal */}
          <Modal
            show={showJobTitleFilter}
            onHide={() => setShowJobTitleFilter(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Filter by Job Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Control
                type="text"
                placeholder="Search Job Titles"
                value={searchTitleText}
                onChange={handleSearchTitleChange}
                className="mb-2"
              />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedTitles.length === jobTitles.length}
                  onChange={(e) => handleSelectAllTitles(e.target.checked)}
                />
                <label className="form-check-label">Select All</label>
              </div>
              {filteredTitles.map((title, idx) => (
                <div className="form-check" key={idx}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedTitles.includes(title)}
                    onChange={() => handleSelectTitle(title)}
                    id={`job-title-${idx}`}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`job-title-${idx}`}
                  >
                    {title}
                  </label>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        {/* Resume View Modal */}
        <Modal
          show={showResumeModal}
          onHide={() => setShowResumeModal(false)}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Candidate Resume</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: "80vh" }}>
            {resumeUrl ? (
              <iframe
                src={resumeUrl}
                title="Resume"
                style={{ width: "100%", height: "100%", border: "none" }}
              ></iframe>
            ) : (
              <p>Resume not available.</p>
            )}
          </Modal.Body>
        </Modal>
      </div>

      {/* --modal-- */}
      <Modal
        show={showCandidateModal}
        onHide={closeCandidateModal}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Candidate Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedCandidate ? (
            <>
              {/* Section 1: Personal Info */}
              <div className="card mb-4 shadow-sm p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 text-uppercase text-primary">
                    {selectedCandidate.candidateName}
                  </h5>
                  <p className="text-muted small mb-0">
                    <i className="bi bi-geo-alt text-info me-1"></i>
                    {selectedCandidate.currentLocation || "-NA-"}
                  </p>
                </div>
                <hr />
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-envelope text-info me-1"></i>Email
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.email || "-NA-"}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-telephone text-info me-1"></i>Mobile
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.mobile || "-NA-"}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-briefcase text-info me-1"></i>Total
                        Exp.
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.totalExperience || "-NA-"}
                      </span>
                    </div>
                    {selectedCandidate.dateOfBirth && (
                      <div className="col-md-6 col-12">
                        <p className="text-muted small mb-0">
                          <i className="bi bi-calendar text-info me-1"></i>DOB
                        </p>
                        <span className="fw-semibold small">
                          {selectedCandidate.dateOfBirth}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Section 2: Job Info */}
              <div className="card mb-4 shadow-sm p-3">
                <div className="d-flex align-items-center mb-3">
                  <h5 className="mb-0 text-uppercase text-primary me-2">
                    {selectedCandidate.jobTitel || "-NA-"}
                  </h5>
                  {selectedCandidate.status && (
                    <span className="badge btn-primary text-white">
                      <i className="bi bi-activity me-1"></i>
                      {selectedCandidate.status}
                    </span>
                  )}
                </div>
                <hr />
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-person-check text-info me-1"></i>
                        Submitted By
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.submitedBy || "-NA-"}{" "}
                        {selectedCandidate.submitByType}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-calendar-event text-info me-1"></i>
                        Submitted Date
                      </p>
                      <span className="fw-semibold small">
                        {new Date(
                          selectedCandidate.submitDate
                        ).toLocaleDateString() || "-NA-"}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-cash-stack text-info me-1"></i>
                        Current CTC
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.currentCTC || "-NA-"}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-graph-up text-info me-1"></i>
                        Expected CTC
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.expectedCTC || "-NA-"}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-calendar-check text-info me-1"></i>
                        Notice Period
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.noticePeriod || "-NA-"}
                      </span>
                    </div>
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-airplane text-info me-1"></i>
                        Ready to Relocate
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.readytoRelocate || "-NA-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 3: Extra Info */}
              <div className="card mb-4 shadow-sm p-3">
                <h5 className="mb-0 text-primary">
                  <i className="bi bi-card-text text-primary me-1"></i>{" "}
                  Description
                </h5>
                <hr />
                <div className="card-body">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedCandidate.descreption,
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <p>No candidate data selected.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeCandidateModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --end modal-- */}
    </>
  );
};

export default GetSentCandidateforJob;
